/* Back-to-School UGC carousel: arrows + scroll progress */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.halloweenUgcReady === 'true') return;
    root.dataset.halloweenUgcReady = 'true';

    var track = root.querySelector('[data-halloween-ugc-track]');
    var prev = root.querySelector('[data-halloween-ugc-prev]');
    var next = root.querySelector('[data-halloween-ugc-next]');
    var progress = root.querySelector('[data-halloween-ugc-progress]');
    if (!track) return;

    function slideStep() {
      var slide = track.querySelector('.halloween-ugc__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '12') || 12;
      return slide.getBoundingClientRect().width + gap;
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
      if (progress) {
        var visibleRatio = track.clientWidth / track.scrollWidth;
        var scrollRatio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        var barWidth = Math.max(visibleRatio * 100, 10);
        progress.style.width = barWidth + '%';
        progress.style.insetInlineStart = scrollRatio * (100 - barWidth) + '%';
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -slideStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: slideStep(), behavior: 'smooth' });
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-halloween-ugc]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-halloween-ugc]');
    if (root) initCarousel(root);
  });
})();
